import React from "react";
import { Table } from "antd";
import CleanButton from "../../common/components/CleanButton";
import Page from "../../common/components/Page";
import useQueryList from "./useQueryList";
import PDFModal from "../../common/components/PDFModal";

const QueryListPage = ({ ...props }) => {
  const { columns, data, handleNewQuery, handleOnExportResult, handleViewPDFModal, visibility, setVisibility, allQueryResult, fromPage } = useQueryList();

  return (
    <Page>
      <Page.Title title="Query List" icon="list" />
      <Page.Toolbar>
        <CleanButton onClick={handleNewQuery} icon="plus">
          New Query
        </CleanButton>
        <CleanButton onClick={handleOnExportResult} icon="file">
          Export Result
        </CleanButton>
        <CleanButton icon="eye" onClick={handleViewPDFModal} loading={visibility}>
          View PDF
        </CleanButton>
      </Page.Toolbar>
      <Page.Content>
        <Table loading={visibility} columns={columns} dataSource={data} scroll={{ x: 720 }} />
      </Page.Content>
      <PDFModal visibility={visibility} setVisibility={setVisibility} data={allQueryResult?.LIST} fromScreen={fromPage} />
    </Page>
  );
};

export default QueryListPage;
